import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import IchimokuCloudSeries from "./IchimokuCloudSeries";

class IchimokuSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForConversion = this.yAccessorForConversion.bind(this);
    this.yAccessorForBase = this.yAccessorForBase.bind(this);
    this.yAccessorForSpanA = this.yAccessorForSpanA.bind(this);
    this.yAccessorForSpanB = this.yAccessorForSpanB.bind(this);
    this.yAccessorForLagging = this.yAccessorForLagging.bind(this);
    this.yAccessorForSpanBScaled = this.yAccessorForSpanBScaled.bind(this);
  }

  yAccessorForConversion(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).conversionLine;
  }

  yAccessorForBase(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).baseLine;
  }

  yAccessorForSpanA(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).spanA;
  }

  yAccessorForSpanB(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).spanB;
  }

  yAccessorForLagging(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).laggingSpan;
  }

  yAccessorForSpanBScaled(scale, d) {
    const { yAccessor } = this.props;
    const ichimoku = yAccessor(d);
    const spanB = ichimoku && ichimoku.spanB;
    const result = spanB !== undefined ? scale(spanB) : undefined;
    return result;
  }

  render() {
    const {
      areaClassName,
      className,
      onDoubleClick,
      onContextMenu,
      yAccessor,
    } = this.props;
    const { conversionLine, baseLine, spanA, spanB, laggingSpan } = this.props;

    // Extract colors from span props for cloud fill
    const spanAColor =
      (typeof spanA === "string" ? spanA : spanA?.color) || "#4CAF50";
    const spanBColor =
      (typeof spanB === "string" ? spanB : spanB?.color) || "#F44336";
    const cloudOpacity = 0.2;

    return (
      <g className={className} style={{ cursor: "pointer" }}>
        {/* Cloud area with dynamic color based on Span A vs Span B */}
        <IchimokuCloudSeries
          className={areaClassName}
          yAccessor={yAccessor}
          base={this.yAccessorForSpanBScaled}
          bullishFill={spanAColor}
          bearishFill={spanBColor}
          opacity={cloudOpacity}
        />

        {/* Conversion Line (Tenkan-sen) */}
        <LineSeries
          yAccessor={this.yAccessorForConversion}
          stroke={conversionLine}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />

        {/* Base Line (Kijun-sen) */}
        <LineSeries
          yAccessor={this.yAccessorForBase}
          stroke={baseLine}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />

        {/* Leading Span A (Senkou Span A) */}
        <LineSeries
          yAccessor={this.yAccessorForSpanA}
          stroke={spanA}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />

        {/* Leading Span B (Senkou Span B) */}
        <LineSeries
          yAccessor={this.yAccessorForSpanB}
          stroke={spanB}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />

        {/* Lagging Span (Chikou Span) */}
        <LineSeries
          yAccessor={this.yAccessorForLagging}
          stroke={laggingSpan}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

IchimokuSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  className: PropTypes.string,
  areaClassName: PropTypes.string,
  type: PropTypes.string,
  conversionLine: PropTypes.object.isRequired,
  baseLine: PropTypes.object.isRequired,
  spanA: PropTypes.object.isRequired,
  spanB: PropTypes.object.isRequired,
  laggingSpan: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

IchimokuSeries.defaultProps = {
  className: "react-stockcharts-ichimoku-series",
  areaClassName: "react-stockcharts-ichimoku-series-area",
  conversionLine: { color: "#2196F3", dash: "Solid", width: 1, opacity: 1 },
  baseLine: { color: "#FF9800", dash: "Solid", width: 1, opacity: 1 },
  spanA: { color: "#4CAF50", dash: "Solid", width: 1, opacity: 1 },
  spanB: { color: "#F44336", dash: "Solid", width: 1, opacity: 1 },
  laggingSpan: { color: "#9C27B0", dash: "Solid", width: 1, opacity: 1 },
};

export default IchimokuSeries;
